"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZERO_ADDRESS = "0x".concat('0'.repeat(40));